<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-33">
        <md-field :class="!checkArea(typeInfo.area) ? 'md-invalid' : ''">
          <label for="area">{{ $t("typeInfo.areaOther") }} (ha)</label>
          <md-input type="number" step="0.01" name="area" v-model="typeInfo.area" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-33">
        <md-field :class="!checkPercentage(typeInfo.trees_nr) ? 'md-invalid' : ''">
          <label for="treesNr">{{ $t("typeInfo.treesNr") }} %</label>
          <md-input type="number" name="treesNr" v-model="typeInfo.trees_nr" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-33">
        <md-field :class="!checkRange(typeInfo.total_volume, 0, 99999) ? 'md-invalid' : ''">
          <label for="totalVolume">{{ $t("typeInfo.totalVolume") }} m³</label>
          <md-input type="number" name="totalVolume" v-model="typeInfo.total_volume" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>
    </div>

    <div v-for="(ts, i) in typeInfo.species" class="md-layout md-gutter" :key="i">
      <div class="md-layout-item md-size-30" v-if="ts !== null">
        <md-field>
          <std-autocomplete
            v-if="loadStd"
            :data="stdList"
            :label="$t('typeInfo.species')"
            :initialValue="ts.specie_std2"
            :initialDisplay="initSpecie[i]"
            :index="i"
            @result="getSpecie"></std-autocomplete>
        </md-field>
      </div>
      <div class="md-layout-item md-size-20" v-if="ts !== null">
        <md-field :class="!checkRange(ts.trees_lt_10_nr, 0, 99999) ? 'md-invalid' : ''" class="woods-field">
          <label for="treesLt10">{{ $t("typeInfo.trees") }} &lt;10cm (N°)</label>
          <md-input type="number" name="treesLt10" v-model="ts.trees_lt_10_nr" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-20" v-if="ts !== null">
        <md-field :class="!checkRange(ts.trees_10_22_nr, 0, 99999) ? 'md-invalid' : ''" class="woods-field">
          <label for="trees1022">{{ $t("typeInfo.trees") }} 10-22cm (N°)</label>
          <md-input type="number" name="trees1022" v-model="ts.trees_10_22_nr" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-20" v-if="ts !== null">
        <md-field :class="!checkRange(ts.trees_gt_22_nr, 0, 99999) ? 'md-invalid' : ''" class="woods-field">
          <label for="treesGt22">{{ $t("typeInfo.trees") }} &gt;22cm (N°)</label>
          <md-input type="number" name="treesGt22" v-model="ts.trees_gt_22_nr" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-10" v-if="ts !== null">
        <md-icon @click.native="removeSpecie(i)" v-show="btn.rm">clear</md-icon>
      </div>
    </div>

    <div class="md-layout md-gutter md-alignment-center-center">
      <md-button class="md-raised md-primary" @click="addSpecie()" v-show="btn.add">{{ $t("global.add") }} {{ $t('global.specie') }}</md-button>
    </div>

    <error-dialog :show="error" :text="$t('error.dataCheck')" @closeError="error = false" />
  </div>
</template>

<script>
import StdAutocomplete from '@/components/StdAutocomplete'
import ErrorDialog from '@/components/ErrorDialog'

import EventBus from '@/event-bus'
import { getDomain } from '@/assets/scripts/domainsManager'
import { checkPercentage, checkArea, checkRange, normalize, formatList, getValue } from '@/assets/scripts/formatData'

const STD2 = 'std2'

const SPECIE = {
  specie_std2: '',
  trees_lt_10_nr: null,
  trees_10_22_nr: null,
  trees_gt_22_nr: null
}

export default {
  name: 'IllegalCutting',
  components: {
    StdAutocomplete,
    ErrorDialog
  },
  data: () => ({
    typeInfo: {
      area: null,
      trees_nr: null,
      total_volume: null,
      species: [{ ...SPECIE }]
    },
    stdList: [],
    loadStd: false,
    initSpecie: [],
    btn: {
      rm: false,
      add: true
    },
    edit: false,
    checkPercentage: checkPercentage,
    checkArea: checkArea,
    checkRange: checkRange,
    error: false
  }),
  mounted () {
    this.$store.state.plot.id === null ? this.edit = false : this.edit = true
    this.setLists()

    if (this.edit) {
      this.typeInfo = this.$store.state.plot.typeInfo // ref to store
      this.setSpecie()
    }

    EventBus.$on('save', () => {
      this.saveData()
    })
  },
  methods: {
    saveData: function () {
      if (this.checkData()) {
        this.typeInfo.species = this.typeInfo.species.filter(el => {
          return el != null
        })
        if (this.typeInfo.area !== null) this.typeInfo.area = normalize(this.typeInfo.area, 2)
        if (this.typeInfo.trees_nr !== null) this.typeInfo.trees_nr = normalize(this.typeInfo.trees_nr, 0)
        if (this.typeInfo.total_volume !== null) this.typeInfo.total_volume = normalize(this.typeInfo.total_volume, 0)
        this.typeInfo.species.forEach(item => {
          if (item.trees_lt_10_nr !== null) item.trees_lt_10_nr = normalize(item.trees_lt_10_nr, 0)
          if (item.trees_10_22_nr !== null) item.trees_10_22_nr = normalize(item.trees_10_22_nr, 0)
          if (item.trees_gt_22_nr !== null) item.trees_gt_22_nr = normalize(item.trees_gt_22_nr, 0)
        })

        this.edit ? this.$emit('typeInfo', null) : this.$emit('typeInfo', this.typeInfo)
      } else {
        this.error = true
      }
    },

    setLists: function () {
      getDomain(STD2).then(data => {
        this.stdList = formatList(data[this.$i18n.locale])
        if (this.edit) {
          this.typeInfo.species.forEach((specie, i) => {
            this.initSpecie[i] = getValue(this.stdList, specie.specie_std2)
          })
        }
        this.loadStd = true
      })
    },

    addSpecie: function () {
      this.typeInfo.species.push({ ...SPECIE })
      this.btn.rm = true
      if (this.getLength() === 3) {
        this.btn.add = false
      }
    },

    removeSpecie: function (index) {
      this.$set(this.typeInfo.species, index, null)
      this.btn.add = true
      if (this.getLength() === 1) {
        this.btn.rm = false
      }
    },

    setSpecie: function () {
      if (this.getLength() > 1) {
        this.btn.rm = true
        if (this.getLength() === 3) {
          this.btn.add = false
        }
      }
    },

    getSpecie: function (value, index) {
      this.typeInfo.species[index].specie_std2 = value
    },

    getLength: function () {
      let length = 0
      this.typeInfo.species.filter(el => {
        if (el != null) length++
      })

      return length
    },

    checkData: function () {
      let checkSpecie = true
      this.typeInfo.species.forEach(specie => {
        if (specie !== null) {
          if (!checkRange(specie.trees_lt_10_nr, 0, 99999)) checkSpecie = false
          if (!checkRange(specie.trees_10_22_nr, 0, 99999)) checkSpecie = false
          if (!checkRange(specie.trees_gt_22_nr, 0, 99999)) checkSpecie = false
        }
      })

      return checkArea(this.typeInfo.area) && checkPercentage(this.typeInfo.trees_nr) && checkRange(this.typeInfo.total_volume, 0, 99999) && checkSpecie
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .woods-field {
    margin-top: 12px;
  }
</style>
